export const emojiCategories = {
  smileys: [
    { emoji: "😀", name: "grinning face" },
    { emoji: "😃", name: "grinning face with big eyes" },
    { emoji: "😄", name: "grinning face with smiling eyes" },
    { emoji: "😁", name: "beaming face with smiling eyes" },
    { emoji: "😆", name: "grinning squinting face" },
    { emoji: "😅", name: "grinning face with sweat" },
    { emoji: "😂", name: "face with tears of joy" },
    { emoji: "🤣", name: "rolling on the floor laughing" },
    { emoji: "😊", name: "smiling face with smiling eyes" },
    { emoji: "😇", name: "smiling face with halo" },
    { emoji: "🙂", name: "slightly smiling face" },
    { emoji: "🙃", name: "upside-down face" },
    { emoji: "😉", name: "winking face" },
    { emoji: "😌", name: "relieved face" },
    { emoji: "😍", name: "smiling face with heart eyes" },
    { emoji: "🥰", name: "smiling face with hearts" },
    { emoji: "😘", name: "face blowing a kiss" },
    { emoji: "😗", name: "kissing face" },
    { emoji: "😙", name: "kissing face with smiling eyes" },
    { emoji: "😚", name: "kissing face with closed eyes" },
    { emoji: "😋", name: "face savoring food" },
    { emoji: "😛", name: "face with tongue" },
    { emoji: "😝", name: "squinting face with tongue" },
    { emoji: "😜", name: "winking face with tongue" },
    { emoji: "🤪", name: "zany face" },
    { emoji: "🤨", name: "face with raised eyebrow" },
    { emoji: "🧐", name: "face with monocle" },
    { emoji: "🤓", name: "nerd face" },
    { emoji: "😎", name: "face with sunglasses" },
    { emoji: "🤩", name: "star-struck" },
    { emoji: "🥳", name: "partying face" },
    { emoji: "😏", name: "smirking face" },
    { emoji: "😒", name: "unamused face" },
    { emoji: "😞", name: "disappointed face" },
    { emoji: "😔", name: "pensive face" },
    { emoji: "😟", name: "worried face" },
    { emoji: "😕", name: "confused face" },
    { emoji: "🙁", name: "slightly frowning face" },
    { emoji: "☹️", name: "frowning face" },
    { emoji: "😣", name: "persevering face" },
    { emoji: "😖", name: "confounded face" },
    { emoji: "😫", name: "tired face" },
    { emoji: "😩", name: "weary face" },
    { emoji: "🥺", name: "pleading face" },
    { emoji: "😢", name: "crying face" },
    { emoji: "😭", name: "loudly crying face" },
    { emoji: "😤", name: "face with steam from nose" },
    { emoji: "😠", name: "angry face" },
    { emoji: "😡", name: "pouting face" },
    { emoji: "🤬", name: "face with symbols on mouth" },
    { emoji: "🤯", name: "exploding head" },
    { emoji: "😳", name: "astonished face" },
    { emoji: "🥵", name: "hot face" },
    { emoji: "🥶", name: "cold face" },
    { emoji: "😱", name: "face screaming in fear" },
    { emoji: "😨", name: "fearful face" },
    { emoji: "😰", name: "anxious face with sweat" },
    { emoji: "😥", name: "sad but relieved face" },
    { emoji: "😓", name: "downcast face with sweat" },
    { emoji: "🤗", name: "hugging face" },
    { emoji: "🤔", name: "thinking face" },
    { emoji: "🤭", name: "face with hand over mouth" },
    { emoji: "🤫", name: "shushing face" },
    { emoji: "🤥", name: "lying face" },
    { emoji: "😶", name: "face without mouth" },
    { emoji: "😐", name: "neutral face" },
    { emoji: "😑", name: "expressionless face" },
    { emoji: "😯", name: "hushed face" },
    { emoji: "😦", name: "frowning face with open mouth" },
    { emoji: "😧", name: "anguished face" },
    { emoji: "😮", name: "face with open mouth" },
    { emoji: "😲", name: "astonished face" },
    { emoji: "😴", name: "sleeping face" },
    { emoji: "🤤", name: "drooling face" },
    { emoji: "😪", name: "sleepy face" },
    { emoji: "😵", name: "face with crossed-out eyes" },
    { emoji: "🤐", name: "zipper-mouth face" },
    { emoji: "🥴", name: "woozy face" },
    { emoji: "🤢", name: "nauseated face" },
    { emoji: "🤮", name: "face vomiting" },
    { emoji: "🤧", name: "sneezing face" },
    { emoji: "😷", name: "face with medical mask" },
    { emoji: "🤒", name: "face with thermometer" },
    { emoji: "🤕", name: "face with head-bandage" },
    { emoji: "🤑", name: "money-mouth face" },
    { emoji: "🤠", name: "cowboy hat face" },
    { emoji: "💩", name: "pile of poo" },
    { emoji: "👻", name: "ghost" },
    { emoji: "💀", name: "skull" },
    { emoji: "☠️", name: "skull and crossbones" },
    { emoji: "👽", name: "alien" },
    { emoji: "👾", name: "alien monster" },
    { emoji: "🤖", name: "robot" },
    { emoji: "😺", name: "grinning cat" },
    { emoji: "😸", name: "grinning cat with smiling eyes" },
    { emoji: "😹", name: "cat with tears of joy" },
    { emoji: "😻", name: "heart eyes cat" },
    { emoji: "😼", name: "cat with wry smile" },
    { emoji: "😽", name: "kissing cat" },
    { emoji: "🙀", name: "weary cat" },
    { emoji: "😿", name: "crying cat" },
    { emoji: "😾", name: "pouting cat" },
    { emoji: "🙈", name: "see-no-evil monkey" },
    { emoji: "🙉", name: "hear-no-evil monkey" },
    { emoji: "🙊", name: "speak-no-evil monkey" },
    { emoji: "👶", name: "baby" },
    { emoji: "👧", name: "girl" },
    { emoji: "🧒", name: "child" },
    { emoji: "👦", name: "boy" },
    { emoji: "👩", name: "woman" },
    { emoji: "🧑", name: "person" },
    { emoji: "👨", name: "man" },
    { emoji: "👵", name: "old woman" },
    { emoji: "🧓", name: "old person" },
    { emoji: "👴", name: "old man" },
    { emoji: "👮", name: "police officer" },
    { emoji: "🕵️", name: "detective" },
    { emoji: "👷", name: "construction worker" },
    { emoji: "👸", name: "princess" },
    { emoji: "🤴", name: "prince" },
    { emoji: "👳", name: "person wearing turban" },
    { emoji: "👲", name: "person with skullcap" },
    { emoji: "🧕", name: "woman with headscarf" },
    { emoji: "🤵", name: "person in tuxedo" },
    { emoji: "👰", name: "person with veil" },
    { emoji: "🤰", name: "pregnant woman" },
    { emoji: "🤱", name: "breast-feeding" },
    { emoji: "👼", name: "baby angel" },
    { emoji: "🎅", name: "santa claus" },
    { emoji: "🤶", name: "mrs. claus" },
    { emoji: "🧙", name: "mage" },
    { emoji: "🧚", name: "fairy" },
    { emoji: "🧛", name: "vampire" },
    { emoji: "🧜", name: "merperson" },
    { emoji: "🧝", name: "elf" },
    { emoji: "🧞", name: "genie" },
    { emoji: "🧟", name: "zombie" },
    { emoji: "🧌", name: "troll" },
    { emoji: "👹", name: "ogre" },
    { emoji: "👺", name: "goblin" },
  ],
  gestures: [
    { emoji: "👋", name: "waving hand" },
    { emoji: "🤚", name: "raised back of hand" },
    { emoji: "🖐️", name: "hand with fingers splayed" },
    { emoji: "✋", name: "raised hand" },
    { emoji: "🖖", name: "vulcan salute" },
    { emoji: "👌", name: "ok hand" },
    { emoji: "🤌", name: "pinched fingers" },
    { emoji: "🤏", name: "pinching hand" },
    { emoji: "✌️", name: "victory hand" },
    { emoji: "🤞", name: "crossed fingers" },
    { emoji: "🤟", name: "love-you gesture" },
    { emoji: "🤘", name: "rock on" },
    { emoji: "🤙", name: "call me hand" },
    { emoji: "👈", name: "backhand index pointing left" },
    { emoji: "👉", name: "backhand index pointing right" },
    { emoji: "👆", name: "backhand index pointing up" },
    { emoji: "🖕", name: "middle finger" },
    { emoji: "👇", name: "backhand index pointing down" },
    { emoji: "☝️", name: "index pointing up" },
    { emoji: "👍", name: "thumbs up" },
    { emoji: "👎", name: "thumbs down" },
    { emoji: "✊", name: "raised fist" },
    { emoji: "👊", name: "oncoming fist" },
    { emoji: "🤛", name: "left-facing fist" },
    { emoji: "🤜", name: "right-facing fist" },
    { emoji: "👏", name: "clapping hands" },
    { emoji: "🙌", name: "raising hands" },
    { emoji: "👐", name: "open hands" },
    { emoji: "🤲", name: "palms up together" },
    { emoji: "🤝", name: "handshake" },
    { emoji: "🙏", name: "folded hands" },
    { emoji: "✍️", name: "writing hand" },
    { emoji: "💪", name: "flexed biceps" },
    { emoji: "🦾", name: "mechanical arm" },
    { emoji: "🦿", name: "mechanical leg" },
    { emoji: "🦵", name: "leg" },
    { emoji: "🦶", name: "foot" },
    { emoji: "👂", name: "ear" },
    { emoji: "🦻", name: "ear with hearing aid" },
    { emoji: "👃", name: "nose" },
    { emoji: "🧠", name: "brain" },
    { emoji: "🫀", name: "anatomical heart" },
    { emoji: "🫁", name: "lungs" },
    { emoji: "🦷", name: "tooth" },
    { emoji: "骨", name: "bone" },
    { emoji: "👀", name: "eyes" },
    { emoji: "👁️", name: "eye" },
    { emoji: "👅", name: "tongue" },
    { emoji: "👄", name: "mouth" },
    { emoji: "💋", name: "kiss mark" },
    { emoji: "🩸", name: "drop of blood" },
    { emoji: "💧", name: "droplet" },
    { emoji: "💦", name: "sweat droplets" },
    { emoji: "💨", name: "dashing away" },
    { emoji: "🫧", name: "bubbles" },
    { emoji: "💢", name: "anger symbol" },
    { emoji: "💥", name: "collision" },
    { emoji: "💫", name: "dizzy" },
  ],
  nature: [
    { emoji: "🌱", name: "seedling" },
    { emoji: "🌲", name: "evergreen tree" },
    { emoji: "🌳", name: "deciduous tree" },
    { emoji: "🌴", name: "palm tree" },
    { emoji: "🌵", name: "cactus" },
    { emoji: "🌾", name: "sheaf of rice" },
    { emoji: "🌿", name: "herb" },
    { emoji: "☘️", name: "shamrock" },
    { emoji: "🍀", name: "four leaf clover" },
    { emoji: "🍁", name: "maple leaf" },
    { emoji: "🍂", name: "fallen leaf" },
    { emoji: "🍃", name: "leaf fluttering in wind" },
    { emoji: "🌺", name: "hibiscus" },
    { emoji: "🌸", name: "cherry blossom" },
    { emoji: "🌼", name: "daisy" },
    { emoji: "🌻", name: "sunflower" },
    { emoji: "🌞", name: "sun with face" },
    { emoji: "🌝", name: "full moon with face" },
    { emoji: "🌛", name: "first quarter moon with face" },
    { emoji: "🌜", name: "last quarter moon with face" },
    { emoji: "🌚", name: "new moon with face" },
    { emoji: "🌕", name: "full moon" },
    { emoji: "🌖", name: "waning gibbous moon" },
    { emoji: "🌗", name: "last quarter moon" },
    { emoji: "🌘", name: "waning crescent moon" },
    { emoji: "🌑", name: "new moon" },
    { emoji: "🌒", name: "waxing crescent moon" },
    { emoji: "🌓", name: "first quarter moon" },
    { emoji: "🌔", name: "waxing gibbous moon" },
    { emoji: "🌙", name: "crescent moon" },
    { emoji: "🌎", name: "earth globe americas" },
    { emoji: "🌍", name: "earth globe europe-africa" },
    { emoji: "🌏", name: "earth globe asia-australia" },
    { emoji: "💫", name: "dizzy" },
    { emoji: "⭐", name: "star" },
    { emoji: "🌟", name: "glowing star" },
    { emoji: "✨", name: "sparkles" },
    { emoji: "⚡", name: "high voltage" },
    { emoji: "☄️", name: "comet" },
    { emoji: "💥", name: "collision" },
    { emoji: "🔥", name: "fire" },
    { emoji: "🌪️", name: "tornado" },
    { emoji: "🌈", name: "rainbow" },
    { emoji: "☀️", name: "sun" },
    { emoji: "🌤️", name: "sun behind small cloud" },
    { emoji: "⛅", name: "sun behind cloud" },
    { emoji: "🌥️", name: "sun behind large cloud" },
    { emoji: "☁️", name: "cloud" },
    { emoji: "🌦️", name: "sun behind rain cloud" },
    { emoji: "🌧️", name: "cloud with rain" },
    { emoji: "⛈️", name: "cloud with lightning and rain" },
    { emoji: "🌩️", name: "cloud with lightning" },
    { emoji: "🌨️", name: "cloud with snow" },
    { emoji: "🌫️", name: "fog" },
    { emoji: "🌬️", name: "wind face" },
    { emoji: "💨", name: "dashing away" },
    { emoji: "💧", name: "droplet" },
    { emoji: "💦", name: "sweat droplets" },
    { emoji: "☔", name: "umbrella with rain drops" },
    { emoji: "☂️", name: "umbrella" },
    { emoji: "🌊", name: "wave" },
    { emoji: "🍏", name: "green apple" },
    { emoji: "🍎", name: "red apple" },
    { emoji: "🍐", name: "pear" },
    { emoji: "🍊", name: "tangerine" },
    { emoji: "🍋", name: "lemon" },
    { emoji: "🍌", name: "banana" },
    { emoji: "🍉", name: "watermelon" },
    { emoji: "🍇", name: "grapes" },
    { emoji: "🍓", name: "strawberry" },
    { emoji: "🫐", name: "blueberries" },
    { emoji: "🍈", name: "melon" },
    { emoji: "🍒", name: "cherries" },
    { emoji: "🍑", name: "peach" },
    { emoji: "🥭", name: "mango" },
    { emoji: "🍍", name: "pineapple" },
    { emoji: "🥥", name: "coconut" },
    { emoji: "🥝", name: "kiwi fruit" },
    { emoji: "🍅", name: "tomato" },
  ],
  objects: [
    { emoji: "💻", name: "laptop" },
    { emoji: "⌨️", name: "keyboard" },
    { emoji: "🖥️", name: "desktop computer" },
    { emoji: "🖨️", name: "printer" },
    { emoji: "鼠标", name: "computer mouse" },
    { emoji: "🖲️", name: "trackball" },
    { emoji: "💽", name: "computer disk" },
    { emoji: "💾", name: "floppy disk" },
    { emoji: "💿", name: "optical disk" },
    { emoji: "📀", name: "dvd" },
    { emoji: "📱", name: "mobile phone" },
    { emoji: "📲", name: "mobile phone with arrow" },
    { emoji: "📟", name: "pager" },
    { emoji: "📠", name: "fax machine" },
    { emoji: "🔋", name: "battery" },
    { emoji: "🔌", name: "electric plug" },
    { emoji: "💡", name: "light bulb" },
    { emoji: "🔦", name: "flashlight" },
    { emoji: "🕯️", name: "candle" },
    { emoji: "🪔", name: "diya lamp" },
    { emoji: "🧯", name: "fire extinguisher" },
    { emoji: "🛢️", name: "oil drum" },
    { emoji: "💸", name: "money with wings" },
    { emoji: "💵", name: "dollar banknote" },
    { emoji: "💴", name: "yen banknote" },
    { emoji: "💶", name: "euro banknote" },
    { emoji: "💷", name: "pound banknote" },
    { emoji: "🪙", name: "coin" },
    { emoji: "💰", name: "money bag" },
    { emoji: "💳", name: "credit card" },
    { emoji: "💎", name: "gem stone" },
    { emoji: "⚖️", name: "balance scale" },
    { emoji: "🪜", name: "ladder" },
    { emoji: "🧰", name: "toolbox" },
    { emoji: "🪛", name: "screwdriver" },
    { emoji: "🔧", name: "wrench" },
    { emoji: "🔨", name: "hammer" },
    { emoji: "⚒️", name: "hammer and pick" },
    { emoji: "🛠️", name: "hammer and wrench" },
    { emoji: "⛏️", name: "pick" },
    { emoji: "🪚", name: "saw" },
    { emoji: "🔩", name: "nut and bolt" },
    { emoji: "⚙️", name: "gear" },
    { emoji: "🪤", name: "mouse trap" },
    { emoji: "🧲", name: "magnet" },
    { emoji: "⛓️", name: "chains" },
    { emoji: "🪝", name: "hook" },
    { emoji: "🧱", name: "brick" },
    { emoji: "🪞", name: "mirror" },
    { emoji: "🪟", name: "window" },
    { emoji: "🪑", name: "chair" },
  ],
  symbols: [
    { emoji: "❤️", name: "red heart" },
    { emoji: "🧡", name: "orange heart" },
    { emoji: "💛", name: "yellow heart" },
    { emoji: "💚", name: "green heart" },
    { emoji: "💙", name: "blue heart" },
    { emoji: "💜", name: "purple heart" },
    { emoji: "🖤", name: "black heart" },
    { emoji: "🤍", name: "white heart" },
    { emoji: "🤎", name: "brown heart" },
    { emoji: "💔", name: "broken heart" },
    { emoji: "❣️", name: "heart exclamation" },
    { emoji: "💕", name: "two hearts" },
    { emoji: "💞", name: "revolving hearts" },
    { emoji: "💓", name: "beating heart" },
    { emoji: "💗", name: "growing heart" },
    { emoji: "💖", name: "sparkling heart" },
    { emoji: "💘", name: "heart with arrow" },
    { emoji: "💝", name: "heart with ribbon" },
    { emoji: "💟", name: "heart decoration" },
    { emoji: "☮️", name: "peace symbol" },
    { emoji: "✝️", name: "latin cross" },
    { emoji: "☪️", name: "star and crescent" },
    { emoji: "🕉️", name: "om" },
    { emoji: "☸️", name: "wheel of dharma" },
    { emoji: "✡️", name: "star of david" },
    { emoji: "🔯", name: "dotted six-pointed star" },
    { emoji: "🕎", name: "menorah" },
    { emoji: "☯️", name: "yin yang" },
    { emoji: "☦️", name: "orthodox cross" },
    { emoji: "🛐", name: "place of worship" },
    { emoji: "⛎", name: "ophiuchus" },
    { emoji: "♈", name: "aries" },
    { emoji: "♉", name: "taurus" },
    { emoji: "♊", name: "gemini" },
    { emoji: "♋", name: "cancer" },
    { emoji: "♌", name: "leo" },
    { emoji: "♍", name: "virgo" },
    { emoji: "♎", name: "libra" },
    { emoji: "♏", name: "scorpio" },
    { emoji: "♐", name: "sagittarius" },
    { emoji: "♑", name: "capricorn" },
    { emoji: "♒", name: "aquarius" },
    { emoji: "♓", name: "pisces" },
    { emoji: "🆔", name: "id button" },
    { emoji: "⚛️", name: "atom symbol" },
    { emoji: "🉑", name: "japanese acceptable button" },
    { emoji: "☢️", name: "radioactive" },
    { emoji: "☣️", name: "biohazard" },
    { emoji: "📴", name: "mobile phone off" },
    { emoji: "📳", name: "vibration mode" },
    { emoji: "🈶", name: "japanese not free of charge button" },
    { emoji: "🈚", name: "japanese free of charge button" },
    { emoji: "🈸", name: "japanese application button" },
    { emoji: "🈺", name: "japanese open for business button" },
    { emoji: "🈷️", name: "japanese monthly amount button" },
    { emoji: "✴️", name: "eight-pointed star" },
    { emoji: "🆚", name: "japanese vs button" },
    { emoji: "💮", name: "japanese congratulations button" },
    { emoji: "🉐", name: "japanese bargain button" },
    { emoji: "㊙️", name: "japanese secret button" },
    { emoji: "㊗️", name: "japanese congratulations button" },
    { emoji: "🈴", name: "japanese passing grade button" },
    { emoji: "🈵", name: "japanese no vacancy button" },
  ],
};
